Ext.define('SA.view.ExportShapefilesWindow', {
    alias: 'widget.export-shapefiles-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-shapefiles',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    initComponent() {
        var win = this,
            map = win.map,
            attributes = win.attributes = [],
            attribute = map.getAttribute();

        if (attribute) {
            attributes.push(attribute);
        }

        win.location = map.getLocation();
        win.geographicUnit = map.getGeographicUnit();

        win.items = [
            {
                xtype: 'simple-container',

                items: [
                    {
                        xtype: 'close-button'
                    }, {
                        xtype: 'component',
                        cls: 'sa-shapefiles-heading',
                        html: '<div class="sa-shapefiles-title">Export Shapefiles</div>'
                    }
                ],

                layout: {
                    type: 'auto'
                }
            }, {
                xtype: 'simple-container',
                cls: 'sa-shapefiles-body',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-shapefiles-step',
                        margin: '19 71 0 40',

                        html: [
                            '<svg>',
                                '<use href="#sa-icon-step-1"></use>',
                            '</svg>',
                            '<div>Select a Location</div>'
                        ]
                    }, {
                        xtype: 'combo-button',
                        flex: 1,
                        height: 54,
                        itemId: 'locationBtn',
                        textField: 'name',

                        buildItems() {
                            return SA.data.LocationsCache.get(map.getProject().getLocations());
                        },

                        selectHandler(location) {
                            win.location = SA.data.LocationsCache.toLocationSeries(location);
                            win.refresh();
                        }
                    }, {
                        xtype: 'component',
                        cls: 'sa-shapefiles-step',
                        margin: '0 71 0 40',

                        html: [
                            '<svg>',
                                '<use href="#sa-icon-step-2"></use>',
                            '</svg>',
                            '<div>Select a Geographic Unit</div>'
                        ]
                    }, {
                        xtype: 'combo-button',
                        emptyText: 'No suitable units available',
                        flex: 1,
                        height: 54,
                        itemId: 'unitBtn',
                        textField: 'name',
                        valueField: 'id',

                        menu: {
                            listeners: {
                                beforeshow(menu) {
                                    menu.ownerButton.refreshItems();
                                }
                            }
                        },

                        buildItems() {
                            return win.getGeographicUnits();
                        },

                        selectHandler(unitId) {
                            win.geographicUnit = unitId;
                            win.refresh();
                        }
                    }, {
                        xtype: 'simple-container',
                        cls: 'sa-shapefiles-step',
                        height: 33,
                        itemId: 'variablesLabel',
                        margin: '0 71 0 40',

                        tpl: [
                            '<svg><use href="#sa-icon-step-3"></use></svg>',
                            '<div>Append up to 10 data variables ({attributeCount} selected)</div>'
                        ]
                    }, {
                        xtype: 'export-shapefiles-attribute-list',
                        autoScroll: true,
                        height: 200,
                        itemId: 'variablesList'
                    }, {
                        xtype: 'component',
                        cls: 'sa-shapefiles-step',
                        margin: '0 71 0 40',

                        html: [
                            '<svg>',
                                '<use href="#sa-icon-step-4"></use>',
                            '</svg>',
                            '<div>Email to:</div>'
                        ]
                    }, {
                        xtype: 'sa-textfield',
                        allowBlank: false,
                        cls: 'sa-shapefiles-email-field',
                        height: 56,
                        itemId: 'emailAddress',
                        msgTarget: 'none',
                        vtype: 'email'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-shapefiles-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        itemId: 'sendBtn',
                        text: 'Send',
                        ui: 'primary',
                        width: 118,

                        handler() {
                            var location = SA.data.LocationsCache.toLocationItem(win.location),
                                data = {
                                    attributes: win.reducedAttributes,
                                    emailAddress: win.email.getValue(),
                                    geographicUnit: win.geographicUnit,
                                    viewId: map.getId()
                                };

                            if (SA.data.LocationsCache.isCustomLocation(location)) {
                                data.customLocation = location.id;
                            }
                            else {
                                data.locationSeries = location.id;
                            }

                            SA.Ajax.request({
                                data,
                                expectedErrors: ['ExportLimitException'],
                                method: 'export',
                                resource: 'shapefile',
                            }).then(
                                () => SA.msg('Your Shapefiles export was processed successfully.\n\nAn email has been sent.'),
                                ({message}) => SA.error(message)
                            );

                            SA.msg('Your Shapefiles export is being processed.\n\nYou will receive an email shortly.');

                            win.destroy();
                        }
                    }, {
                        xtype: 'sa-button',
                        text: 'Cancel',
                        width: 118,

                        handler() {
                            win.destroy();
                        }
                    }
                ],

                layout: {
                    type: 'hbox',
                    pack: 'center'
                }
            }
        ];


        win.callParent();

        win.locationBtn = win.down('#locationBtn');
        win.unitBtn = win.down('#unitBtn');
        win.variablesLabel = win.down('#variablesLabel');
        win.variablesList = win.down('#variablesList');
        win.email = win.down('#emailAddress');
        win.sendBtn = win.down('#sendBtn');

        win.email.setValue(SA.User.getEmailAddress());

        win.refresh();
    },

    initEvents() {
        this.callParent();

        this.email.on('change', this.refresh, this);
        this.variablesList.on('click:attribute', this.onAttributeClicked, this);
    },

    getGeographicUnits() {
        var map = this.map,
            project = map.getProject(),
            attributes = SA.data.AttributesCache.get(project.getAttributes()),
            Locations = SA.data.LocationsCache,
            location = Locations.get(this.location),
            discoverableUnits = project.getDiscoverableGeographicUnits(),
            maximumUnit;

        if (location && Locations.toLocationItem(location).type !== 'customLocation') {
            maximumUnit = location.geographicUnit;
        }

        return SA.data.GeographicUnits.find({
            maximum: maximumUnit,

            units: attributes.reduce((array, attribute) => array.concat(attribute.geographicUnits), [])
        }).filter(unit => discoverableUnits.includes(unit.id));
    },

    onAttributeClicked(attribute) {
        var selected = this.attributes = this.reducedAttributes,
            index = selected.indexOf(attribute);

        if (index === -1) {
            selected.push(attribute);
        }
        else {
            selected.splice(index, 1);
        }

        this.refresh();
    },

    refresh() {
        var map = this.map,
            project = map.getProject(),
            allAttributes = SA.data.AttributesCache.get(project.getAttributes()),
            selectedAttributes = this.attributes,
            location = SA.data.LocationsCache.get(this.location),
            unit = SA.data.GeographicUnits.get(this.geographicUnit),
            units = this.getGeographicUnits(),
            attributes = [],
            reducedAttributes = this.reducedAttributes = [],
            attributeCount, unitId, selectedYear;

        if (!units.includes(unit)) {
            unit = units[0];
        }

        if (unit) {
            unitId = unit.id;
            this.geographicUnit = unitId;
        }

        Ext.suspendLayouts();

        if (location) {
            this.locationBtn.setValue(location);
        }

        this.unitBtn.setValue(unitId);

        selectedYear = getImpliedSelectedYear();

        allAttributes.forEach(attribute => {
            if (!map.supportsAttribute(attribute)) {
                return;
            }

            var hasIncompatibleUnits = areUnitsIncompatible(attribute),
                hasDifferentYear = !!selectedYear && attribute.year !== selectedYear,
                disabled = hasIncompatibleUnits || hasDifferentYear,
                selected = !disabled && selectedAttributes.includes(attribute.attribute);

            if (selected) {
                reducedAttributes.push(attribute.attribute);
            }

            attributes.push(Object.assign({
                disabled,
                selected,
                title: getTitle()
            }, attribute));

            function getTitle() {
                if (hasIncompatibleUnits && hasDifferentYear) {
                    return [
                        'This variable is not supported for the selected geographic unit, ',
                        'and is from a different year than the other variable(s) selected for this export'
                    ].join('');
                }
                else if (hasIncompatibleUnits) {
                    return 'This variable is not supported for the selected geographic unit';
                }
                else if (hasDifferentYear) {
                    return 'This variable is from a different year than the other variable(s) selected for this export';
                }

                return '';
            }
        });

        attributeCount = reducedAttributes.length;

        if (attributeCount === 10) {
            attributes.forEach(attribute => {
                if (!attribute.disabled && !attribute.selected) {
                    attribute.disabled = true;
                    attribute.title = 'A maximum of 10 data variables can be selected';
                }
            });
        }

        this.variablesLabel.update({attributeCount});
        this.variablesList.update(attributes);

        this.sendBtn.setDisabled(!attributeCount || !location || !unit || !this.email.isValid());

        Ext.resumeLayouts(true);

        function areUnitsIncompatible(attribute) {
            return !attribute.geographicUnits.includes(unitId);
        }

        function getImpliedSelectedYear() {
            var result = null,
                attributes = SA.data.AttributesCache.get(selectedAttributes);

            Ext.Array.each(attributes, attribute => {
                if (!areUnitsIncompatible(attribute)) {
                    result = attribute.year;

                    return false; 
                }
            });

            return result;
        }
    }
});
